// In production, import.meta.url = https://domain.com/assets/index.js → go up one level to get root
// In dev, Vite serves public files from root, so just use "/"
const fontBaseUrl = import.meta.env.DEV ? "/" : new URL("..", import.meta.url).href;

export const setRootHTMLStyles = () => {
  const styleId = "booking-engine-scroll-lock-style";

  if (!document.getElementById(styleId)) {
    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
    html.be-modal-open,
    body.be-modal-open {
      overflow: hidden !important;
    }
  `;
    document.head.appendChild(style);
  }

  // @font-face must be in light DOM — browsers won't load fonts from shadow DOM.
  // URLs must be absolute to the booking engine's domain, not the host site.
  const fontStyleId = "booking-engine-fonts";
  if (!document.getElementById(fontStyleId)) {
    const base = fontBaseUrl;
    const fontStyleEl = document.createElement("style");
    fontStyleEl.id = fontStyleId;
    fontStyleEl.textContent = `
      @font-face {
        font-family: Roboto;
        src: url("${base}fonts/Roboto-Regular.woff2") format("woff2");
        font-weight: 400;
        font-display: swap;
      }
      @font-face {
        font-family: Roboto;
        src: url("${base}fonts/Roboto-Medium.woff2") format("woff2");
        font-weight: 500;
        font-display: swap;
      }
      @font-face {
        font-family: Roboto;
        src: url("${base}fonts/Roboto-Bold.woff2") format("woff2");
        font-weight: 600;
        font-display: swap;
      }
      @font-face {
        font-family: Roboto;
        src: url("${base}fonts/Roboto-Bold.woff2") format("woff2");
        font-weight: 700;
        font-display: swap;
      }
    `;
    document.head.appendChild(fontStyleEl);
  }
};
